import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {VerifierService} from '../../../user/service/verifier.service';
import {InformType} from '../../../global/util/enum/InformType';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Constant} from '../../../global/util/Constant';
import HttpStatusCode from '../../../global/util/HttpStatusCode';
import {Dialog} from '../../../global/util/Dialog';
import {Document} from '../../../user/model/Document';
import {DocumentState} from '../../../global/util/DocumentState';
import {Documentmodification} from '../../../user/model/Documentmodification';
import {OperationType} from '../../../global/util/OperationType';
import {TypeSignature} from '../../../global/util/TypeSignature';
import {CertificateDetailComponent} from '../certificate-detail/certificate-detail.component';
import {Operator} from '../../../user/model/Operator';
import {BatchOperation} from '../../../global/util/BatchOperation';
import {TranslateService} from '@ngx-translate/core';
import {PublicService} from '../../../user/service/public.service';

@Component({
  selector: 'app-verifier',
  templateUrl: './verifier.component.html',
  styleUrls: ['./verifier.component.css']
})
export class VerifierComponent implements OnInit {
  private hashIdentifier;
  private verificationType;
  private hashResource;
  public operatorsInfo: any[] = [];
  public loading: boolean;
  private url = Constant.ROOT_API_V1.concat('/public');
  public urlStream;
  public wrongVerification = true;
  public verificationMessage = '';
  public document: Document;
  public documentmodifications: Documentmodification[] = [];
  public urlLastDocumentResource: string;
  public resumeHashResource: string;
  public send2Visualization: boolean;
  public havePermissionToDownload: boolean;

  constructor(private activatedRoute: ActivatedRoute,
              private verifierService: VerifierService,
              private modalService: NgbModal,
              private translate: TranslateService,
              private publicService: PublicService) {
    Dialog.createInstance(modalService);
    this.receiveParams();
  }

  public receiveParams() {
    this.activatedRoute.params.subscribe(params => {
      this.hashIdentifier = params.hashIdentifier;
      if (params.hashResource) {
        this.hashResource = params.hashResource;
      }
      if (params.verificationType) {
        this.verificationType = params.verificationType;
      }
    });
    this.verifyHavePermission();
  }

  ngOnInit() {
    this.loadOperatorsInfo(this.hashIdentifier, this.hashResource, this.verificationType);
  }

  private loadOperatorsInfo(hashIdentifier: string, hashResource?: string, verificationType?: string) {
    let urlVerifierOperators = '';
    if (hashResource) {
      if (verificationType) {
        urlVerifierOperators = this.url.concat('/documents/')
          .concat(hashIdentifier)
          .concat('/resources/')
          .concat(hashResource)
          .concat('/verifier1');
      } else {
        urlVerifierOperators = this.url.concat('/documents/')
          .concat(hashIdentifier)
          .concat('/resources/')
          .concat(hashResource)
          .concat('/verifier');
      }
      this.urlStream = this.url.concat('/documents/')
        .concat(hashIdentifier)
        .concat('/resources/')
        .concat(hashResource)
        .concat('/stream');
    } else {
      urlVerifierOperators = this.url.concat('/documents/')
        .concat(hashIdentifier)
        .concat('/verifier');

      this.urlStream = this.url.concat('/documents/')
        .concat(hashIdentifier)
        .concat('/stream');
    }
    this.loading = true;
    this.verifierService.get(urlVerifierOperators).subscribe((next: any) => {
      this.loading = false;
      this.operatorsInfo = next._embedded.operatorsInfo;
      this.send2Visualization = next._embedded.send2Visualization;
      this.documentmodifications = next._embedded.documentmodifications;
      this.urlLastDocumentResource = next._embedded.urlLastDocumentResource;
      this.document = next._embedded.document;
      this.wrongVerification = false;
    }, error => {
      // TODO investigate and improvement next treatment for it doesn't get 404
      if (error.status) {
        this.wrongVerification = true;
        if (HttpStatusCode.NOT_FOUND === error.status ||
          HttpStatusCode.SERVICE_UNAVAILABLE === error.status ||
          HttpStatusCode.METHOD_NOT_ALLOWED === error.status) {
          this.verificationMessage = error.error.message;
        } else if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
          Dialog.show(InformType.Warning, this.translate.instant('TABLE.HEADER.BALANCE-IOF'), error.error.message);
          return;
        } else if (HttpStatusCode.FAILED_DEPENDENCY === error.status) {
          Dialog.show(InformType.Warning, this.translate.instant('TABLE.HEADER.BALANCE-IOF'), error.error.message);
          return;
        } else {
          Dialog.show(InformType.Danger, this.translate.instant('TITLE.VERIFICATION'));
        }
        this.loading = false;
      }
    });
  }

  public hasntCertificate(operatorsInfo: any): boolean {
    return OperationType.REVIEW === operatorsInfo.operationId ||
      (TypeSignature.ELECTRONIC === operatorsInfo.typeSignature &&
        !this.hasDocumentIntegrity(operatorsInfo)) ||
      TypeSignature.CLOUD === operatorsInfo.typeSignature ||
      Constant.CORRECT_OPERATION !== operatorsInfo.correctOperation;
  }

  public openModalSeeCertificateDetail(index: number) {
    const modalRef = this.modalService.open(CertificateDetailComponent, {size: 'lg'});
    modalRef.componentInstance.operatorInfo = this.operatorsInfo[index];
    modalRef.componentInstance.resumeHashResource = this.hashResource;
    modalRef.componentInstance.index = index;
    modalRef.componentInstance.haveDocumentIntegrity = this.hasDocumentIntegrity(this.operatorsInfo[index]);
  }

  public getClassMaxHeight(operatorInfo: Operator[]): string {
    switch (operatorInfo.length) {
      case 0:
        return 'max-height-0';
      case 1:
        return 'max-height-1';
      case 2:
        return 'max-height-2';
      case 3:
        return 'max-height-3';
      case 4:
        return 'max-height-4';
      default:
        return 'max-height-5';
    }
  }

  registerAdditionalData(): void {

    /**
     * Registrar datos de visualización del documento por parte del invitado
     */
    if (this.send2Visualization) {
      this.loading = true;
      const url = Constant.ROOT_API_V1.concat('/public/documents/', this.hashIdentifier, '/resources/', this.hashResource, '/batchoperations/', String(BatchOperation.VISUALIZED), '/register');
      this.verifierService.post(url).subscribe((next: any) => {
        this.loading = false;
      }, error => {
        Dialog.show(InformType.Danger, this.translate.instant('TITLE.VERIFICATION'));
      });
    }
  }

  /* Enviamos la solicitud a backend para verificar si ya paso 1 minuto desde la descarga anterior. */
  verifyIntervalDownloadTime() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/').concat('verify-qr/' + this.hashIdentifier + '/permission/download');
    this.publicService.verifyTimeToDownload(url).subscribe((next: any) => {
      this.loading = false;
      if (Boolean(JSON.parse(next.enabledPermissionDownload)) && Boolean(JSON.parse(next.enabledIntervalTimeDownload))) {
        this.loading = true;
        this.downloadDocument(next);
      } else {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.DOCUMENT-VERIFICATION'), next.message);
      }
    }, error => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.DOCUMENT-VERIFICATION'));
    });
  }

  verifyHavePermission() {
    const url = this.url.concat('/verify-qr/').concat(this.hashIdentifier).concat('/have/permission');
    this.publicService.verifyHavePermission(url).subscribe((next: any) => {
      this.havePermissionToDownload = Boolean(JSON.parse(next.havePermissionDownload));
    }, error => {
      this.havePermissionToDownload = false;
    });
  }

  private downloadDocument(next: any) {
    this.publicService.download(this.urlStream, next.filename).subscribe(blob => {
      this.loading = false;
    }, error => {
      this.loading = false;
      const title = this.translate.instant('TITLE.DOWNLOAD-DOCUMENTS');
      Dialog.show(InformType.Danger, title);
    });
  }

  hasDocumentIntegrity(operatorsInfo: any) {
    return operatorsInfo.documentIntegrity;
  }

  get isCanceled(): boolean {
    if (this.document === undefined) {
      return false;
    }
    return Constant.FINISHED === this.document.finished && DocumentState.CANCELED === this.document.stateId;
  }

  get isModified(): boolean {
    if (this.document === undefined) {
      return false;
    }
    return Constant.FINISHED === this.document.finished && DocumentState.MODIFIED === this.document.stateId;
  }

  get isReplacerFinished(): boolean {
    const maxIndex = this.documentmodifications.length - 1;
    const replacer: Document = this.documentmodifications[maxIndex].documentByDocumentIdNew;
    return Constant.FINISHED === replacer.finished;
  }
}
